import * as React from 'react'
import './LinkDetailModal.scss'
import {connect} from "react-redux";
import { reducerStoreType, linkDetailType} from "../../reducers/types";
import {injectIntl, IntlShape} from "react-intl";
import Grid from "@material-ui/core/Grid";

interface IProps {
    intl: IntlShape,
    linkDetail: linkDetailType
}

interface IState {
}


class LinkDetailModal extends React.Component<IProps, IState> {

    public render() {
        let {linkDetail, intl} = this.props
        return (<div className="orderDetail">
                <div className="content">
                    <Grid container spacing={1}>
                    <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'orderNo'})}:</label>
                            <span>{linkDetail.id}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'transactionStatus'})}:</label>
                            {linkDetail.status === 0 ? 
											<span>
											   {intl.formatMessage({id: 'unpaid'})}
											</span> : 
											<span>
											   {intl.formatMessage({id: 'paid'})}
											</span>
										}
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'amt'})}:</label>
                            <span>{linkDetail.tradeAmt}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'payCurrency'})}:</label>
                            <span>{linkDetail.currency}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'createTime'})}:</label>
                            <span>{linkDetail.createTime}</span>
                        </Grid>
                        <Grid item xs={6} className="orderAttr">
                            <label>{intl.formatMessage({id: 'payTime'})}:</label>
                            <span>{linkDetail.payTime}</span>
                        </Grid>
                        <Grid item xs={12} className="orderAttr">
                            <label>{intl.formatMessage({id: 'remark'})}:</label>
                            <span>{linkDetail.tradeSummary}</span>
                        </Grid>
                        <Grid item xs={12} className="orderAttr" id="paylink">
                            <label>{intl.formatMessage({id: 'collectionLink'})}:</label>
                            <span>{linkDetail.payLink}</span>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        linkDetail: state.searchLink.linkDetail
    }
})(LinkDetailModal))